(function () {
  'use strict';

  function closeDetails(el) {
    var d = el.closest('details');
    if (d) d.removeAttribute('open');
  }

  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-close-details]');
    if (closer) closeDetails(closer);

    var qtyBtn = e.target.closest('[data-qty]');
    if (qtyBtn) {
      var input = qtyBtn.parentNode.querySelector('input');
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var n = parseInt(input.value, 10) || 0;
      n += qtyBtn.getAttribute('data-qty') === 'plus' ? 1 : -1;
      if (n < min) n = min;
      input.value = n;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[open][data-closable]').forEach(function (d) {
      d.removeAttribute('open');
    });
  });

  /* Variant picker */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('input[name="id"]');
    var addBtn = root.querySelector('[data-add-button]');
    var addLabel = root.querySelector('[data-add-label]');
    var priceEl = root.querySelector('[data-price]');
    var fieldsets = root.querySelectorAll('[data-option-index]');
    if (!fieldsets.length) return;

    function selectedOptions() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function matches(v, opts) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    }

    function update() {
      var opts = selectedOptions();
      var v = variants.find(function (x) { return matches(x, opts); });

      fieldsets.forEach(function (fs, idx) {
        var label = fs.querySelector('[data-selected-value]');
        if (label) label.textContent = opts[idx] || '';
        fs.querySelectorAll('input').forEach(function (inp) {
          var test = opts.slice();
          test[idx] = inp.value;
          var ok = variants.some(function (x) { return x.available && matches(x, test); });
          if (inp.nextElementSibling) inp.nextElementSibling.classList.toggle('is-unavailable', !ok);
        });
      });

      if (!v) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? addBtn.getAttribute('data-label-add') : 'Sold out';
      if (priceEl) {
        priceEl.innerHTML = (v.compare ? '<s>' + v.compare + '</s>' : '') + '<span class="price__current">' + v.price + '</span>';
        priceEl.classList.toggle('price--sale', !!v.compare);
      }
      if (v.media) {
        var m = document.querySelector('[data-media-id="' + v.media + '"]');
        if (m && m.parentNode) {
          if (window.innerWidth < 750) m.parentNode.scrollTo({ left: m.offsetLeft - 20, behavior: 'smooth' });
        }
      }
      if (window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });
    update();
  });

  /* Collection sorting and filters */
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });
  document.querySelectorAll('[data-filter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      form.querySelectorAll('input').forEach(function (i) {
        if ((i.type === 'number' || i.type === 'hidden') && !i.value) i.disabled = true;
      });
    });
  });

  /* Cart: update quantities automatically */
  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    var timer;
    form.addEventListener('change', function (e) {
      if (e.target.name !== 'updates[]') return;
      clearTimeout(timer);
      timer = setTimeout(function () { form.submit(); }, 500);
    });
  });

  /* Product recommendations */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || !window.fetch) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });

  /* Customer address country and province selects */
  document.querySelectorAll('[data-country-select]').forEach(function (sel) {
    var prov = document.getElementById(sel.getAttribute('data-province-target'));
    var wrap = prov ? prov.closest('[data-province-wrap]') : null;
    var def = sel.getAttribute('data-default');
    if (def) {
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value === def) { sel.selectedIndex = i; break; }
      }
    }
    function fill() {
      if (!prov) return;
      var opt = sel.options[sel.selectedIndex];
      var list = [];
      try { list = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]'); } catch (err) {}
      prov.innerHTML = '';
      list.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p[0];
        o.textContent = p[1];
        prov.appendChild(o);
      });
      var pd = prov.getAttribute('data-default');
      if (pd) { prov.value = pd; prov.removeAttribute('data-default'); }
      if (wrap) wrap.style.display = list.length ? '' : 'none';
    }
    sel.addEventListener('change', fill);
    fill();
  });
})();
